export const DEAL_RENT_TRAP_MAINPAGE = 'deal_rent_trap_mainpage';

export const NEWBUILDING_PROMOS_IN_SEARCH = 'newbuilding_promos_in_search';

export const SEO_REDESIGN = 'aud_desktop_acti220_home_redesign_ceo';

export const EXPERIMENTS = [DEAL_RENT_TRAP_MAINPAGE, NEWBUILDING_PROMOS_IN_SEARCH, SEO_REDESIGN];
